import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import ModalButton from '../../common/ModalButton';
import auth from '../../../services/authService';
import userService from '../../../services/userService';
import theme from '../../../utils/theme';
import { removeColorTheme } from '../../../utils/colorTheme';

import './AccountRemovedModal.scss';

const AccountRemovedModal = () => {
  const history = useHistory();
  const { t } = useTranslation();

  useLayoutEffect(() => {
    theme.removeDarkTheme();
    removeColorTheme();
  }, []);

  const handleSignOut = () => {
    auth.signout();
    history.push('/');
  };

  const handleJoinNewTeam = () => {
    history.push('/join-team');
  };

  const handleDeleteAccount = async () => {
    if (window.confirm(t('dialogs.accountRemoved.confirmDelete'))) {
      try {
        const user = auth.getCurrentUser();

        await userService.deleteUser(user._id);
        toast.success(t('dialogs.accountRemoved.deleted'));
        auth.signout();
        history.push('/');
      } catch (error) {
        toast.error(t('dialogs.accountRemoved.deleteFailed'));
      }
    }
  };

  return (
    <div className="AccountRemovedModal">
      <p className="message">{t('dialogs.accountRemoved.message')}</p>
      <p className="message">{t('dialogs.accountRemoved.contact')}</p>

      <div className="actions">
        <ModalButton block onClick={handleJoinNewTeam}>
          {t('dialogs.accountRemoved.joinNewTeam')}
        </ModalButton>
        <ModalButton variant="secondary" block onClick={handleSignOut}>
          {t('nav.signOut')}
        </ModalButton>
        <button type="button" className="delete-btn" onClick={handleDeleteAccount}>
          {t('dialogs.accountRemoved.deleteAccount')}
        </button>
      </div>
    </div>
  );
};

export default AccountRemovedModal;
